import apiClient from './apiClient'

export interface VacationBalance {
  employeeId: number
  year: number
  // Dny (přepočtené z hodin ÷ avgDailyHours) — pro zobrazení
  entitlement: number
  carriedOver: number
  used: number
  total: number
  remaining: number
  // Hodiny (uložené v DB) — canonical
  entitlementHours: number
  carriedOverHours: number
  usedHours: number
  totalHours: number
  remainingHours: number
  // Plánováno = čekající (Pending) žádosti o dovolenou
  plannedHours: number
  plannedDays: number
  workloadChangedInYear: boolean   // #24: úvazek se během roku měnil → dny jsou zavádějící
  workloadMismatchCount: number    // #26: počet dovolených s podezřelými hodinami (úvazek v termínu ≠ snapshot)
  // Metadata
  validFrom: string
  resetAt: string | null
  resetNote: string | null
  entitlementReviewNeeded: boolean   // #20: úvazek se změnil → přepočítat nárok ručně
  averageDailyHours: number  // průměrné hodiny/pracovní den dle rozvrhu
  weeklyHours: number
  workingRatioPercent: number
  autoEntitlement: number    // automaticky vypočtený nárok (dny)
}

export interface ResetBalanceRequest {
  year?: number
  entitlement: number
  carriedOver: number
  validFrom?: string
  note?: string
}

export interface RecalculateAllResult {
  year: number
  employeesProcessed: number
  recalcEntitlements: boolean
  errors: string[]
}

export const vacationBalanceService = {
  getMyBalance: () =>
    apiClient.get<VacationBalance>('/vacation-balance/me').then(r => r.data),

  getBalance: (employeeId: number, year?: number) =>
    apiClient.get<VacationBalance>(`/vacation-balance/${employeeId}`, { params: { year } }).then(r => r.data),

  reset: (employeeId: number, data: ResetBalanceRequest) =>
    apiClient.post<VacationBalance>(`/vacation-balance/${employeeId}/reset`, data).then(r => r.data),

  recalculateAll: (year?: number, recalcEntitlements?: boolean) =>
    apiClient.post<RecalculateAllResult>(
      '/vacation-balance/recalculate-all',
      null,
      { params: { ...(year ? { year } : {}), ...(recalcEntitlements ? { recalcEntitlements: true } : {}) } }
    ).then(r => r.data),
}
